import { useAsyncOperationState } from '../../../../dorian-shared/hooks/useAsyncOperationState';
import { Event } from '../../../../dorian-shared/types/event/Event';
import { api } from '../../../api';
import { EventFormValues, createFormDataFromFormValues } from '../components/EventForm/EventForm';

export type UpdateEventResponsePayload = { success?: boolean; event?: Event };

export function useUpdateEvent(eventId: number) {
  const [, {
    isLoading,
    setToLoading,
    setToError,
    setToSuccess,
  }] = useAsyncOperationState();

  const updateEvent = (values: Omit<EventFormValues, 'detailedEventPrizes'>) => {
    setToLoading();
    const formData = createFormDataFromFormValues(values);
    return api.put<UpdateEventResponsePayload>(`/v1/events/${eventId}`, formData, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    })
      .then((response) => {
        setToSuccess();
        return response.data;
      })
      .catch((error) => {
        const possibleErrorFromServer = error.response.data?.error ?? 'There was issue when creating event, please contact support or try again later.';
        setToError();
        throw new Error(possibleErrorFromServer);
      });
  };
  return { isLoading, updateEvent };
}
